import { Component, Vue, Inject } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase';
import PackageInfo from '../../store/entities/handoversessionpackageinfo'
import _ from 'lodash';
import util from '@/lib/util';

@Component
export default class HandoverSessionPackageMixin extends AbpBase {
  namespace: string = 'handoverSessionPackages';
  pagerequest: any = {};

  get store() {
    return null;
  }
  get loading() {
    return this.store.loading;
  }
  get pageSize() {
    return this.store.pageSize;
  }
  get totalCount() {
    return this.store.deliveryPackages.length;
  }
  get currentPage() {
    return this.store.currentPage;
  }
  get list() {
    var re = this.store.list;
    var startIndex = this.totalCount -((this.currentPage - 1) * this.pageSize);
    var index = 0;
    re.forEach(function(item) {
      item.order = startIndex - index;
      index++;
    });
    return re;
  }
  pageChange(page: number) {
    this.$store.commit(`${this.namespace}/setCurrentPage`, page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setPageSize`, pagesize);
    this.getpage();
  }
  preGetPage() {
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.preGetPage();
    var items = this.store.deliveryPackages;
    if (!util.isNull(this.pagerequest.keyword) && !util.isEmpty(this.pagerequest.keyword)) {
      var code = this.pagerequest.keyword;
      items = items.filter((item) => item.packageNo.indexOf(code) >= 0 || item.refCode.indexOf(code) >= 0 || item.externalCode.indexOf(code) >= 0);
    }
    if (!util.isNull(this.pagerequest.uncompletedObjectOnly) && this.pagerequest.uncompletedObjectOnly) {
      items = items.filter((item) => !item.completed);
    }
    this.store.list = util.pagingItems(items, this.pageSize, this.currentPage);
  }
  get numOfPackages() {
    return this.store.deliveryPackages.length;
  }
  get numOfUnCompletedObjects() {
    var retCount = 0;
    var groupPackages = this.store.deliveryPackages.filter((item) => util.isEmpty(item.refCode) && !item.completed);
    retCount += util.isNull(groupPackages) || util.isNull(groupPackages.length) ?0: groupPackages.length;
    var grouped = _.groupBy(this.store.deliveryPackages.filter((item) => util.isEmpty(item.refCode) && !item.completed), 'refCode');
    const listOfObjects = Object.keys(grouped);
    retCount += util.isNull(listOfObjects) || util.isNull(listOfObjects.length) ?0:listOfObjects.length;
    return retCount;
  }
  get numOfCompletedObjects() {
    var retCount = 0;
    var groupPackages = this.store.deliveryPackages.filter((item) => util.isEmpty(item.refCode) && item.completed);
    retCount += util.isNull(groupPackages) || util.isNull(groupPackages.length) ?0: groupPackages.length;
    var grouped = _.groupBy(this.store.deliveryPackages.filter((item) => !util.isEmpty(item.refCode) && item.completed), 'refCode');
    const listOfObjects = Object.keys(grouped);
    retCount += util.isNull(listOfObjects) || util.isNull(listOfObjects.length) ?0:listOfObjects.length;
    return retCount;
  }
  async getItems(sessionId: number, code: string, refCode: string, refTypeCode: string,itemType:string) {
    var items = this.store.deliveryPackages;
    var item = items.reduce((result, item) => {
      if (item.packageNo === code) {
        result = item;
      }
      return result;
    }, null);
    if (item !== null) {
      this.showErrorMsg(util.L('Error.HandoverSession.PackageExisted'));
    }
    else
    {
      await this.$store
      .dispatch({
        type: "handoverSession/scancode",
        data: {
          sessionId: sessionId,
          refCode: refCode,
          refTypeCode: refTypeCode,
          code: code,
          itemType: itemType
        }
      })
      .then(result => {
        this.addDetail(result);
      });
    }
  }
  addDetail(packages: PackageInfo[]) {
    var newPackages = new Array<PackageInfo>();
    var items = this.store.deliveryPackages;
    if (items.length > 0) {
      _.each(packages, function (element) {
        var existedItem = items.find((item) => item.packageNo === element.packageNo && item.refCode == element.refCode)
        if (util.isNull(existedItem)) {
          newPackages.push(element);
        }
      });
    }
    else {
      newPackages = packages;
    }
    if (newPackages.length <= 0) {
      this.showErrorMsg(util.L('Error.NoPackage'));
    }
    else
      this.pushAndOrderPackages(newPackages);
  }
  pushAndOrderPackages(newPackages: PackageInfo[]) {
      var existedItems = this.store.deliveryPackages;
      var items = newPackages.concat(this.store.deliveryPackages);
      const grouped = _.groupBy(items, 'refCode')
      const listOfObjects = Object.keys(grouped);
      _.each(listOfObjects, function (key) {
        var newObjectPackages = newPackages.filter((item) => item.refCode === key);
        if(util.isEmpty(key))
        {
          if(newObjectPackages.length>0)
          {
            _.each(newObjectPackages, function (newItem) {
              newItem.orderPackage = '';
              newItem.completed = true;
            });
          }
        }
        else
        {
          var existedPackages = existedItems.filter((item) => item.refCode === key);
          if(newObjectPackages.length>0)
          {
            var numOfExistedObjectPackages = existedPackages.length;
              var numOfObjectPackages = newObjectPackages[0].numOfPackages;
    
              var index = 1;
              var completedObject = numOfExistedObjectPackages + newObjectPackages.length == numOfObjectPackages;
              var numOfObjectPackagesStr = util.toViewNumberString(numOfObjectPackages);
              _.each(newObjectPackages, function (newItem) {
                newItem.orderPackage = `${util.toViewNumberString((numOfExistedObjectPackages + index))}/${numOfObjectPackagesStr}`;
                newItem.completed = completedObject;
                index++;
              });
              if (completedObject) {
                _.each(existedPackages, function (item) {
                  item.completed = completedObject;
                });
              }
          }
        }
       
      });
    this.store.deliveryPackages = newPackages.concat(this.store.deliveryPackages).sort((a, b) => this.sortDescending(a.order, b.order));
    this.getpage();
    this.afterPushAndOrderPackages();
  }
  afterPushAndOrderPackages()
  {

  }
  sortDescending(a, b) {
    return a > b ? -1 : b > a ? 1 : 0;
  }
  remove(index: number) {
    this.$Modal.confirm({
      title: this.L('Tips'),
      content: this.L(`Confirm.RemoveHandoverSessionPackage`),
      okText: this.L('Yes'),
      cancelText: this.L('No'),
      onOk: async () => {
        var item = this.list[index];
        var items = this.store.deliveryPackages.filter(i => i.packageNo != item.packageNo);
        this.store.deliveryPackages = items;
        await this.getpage();
        this.afterRemove();
      }
    })
  }
  afterRemove()
  {
      
  }
  showErrorMsg(msg: string) {
    util.showNoticeErrorMsg(this,msg);
  }
  created() {
    this.getpage();
  }
}